import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';
import { environment } from '../environments/environment';

export class CookiebotConfig extends NgxCookiebotConfig {
  blockingMode = 'auto';
  cdn = 'eu';
  cbId = environment.cookiebotId;
  loadScript = true;
}
